import { Checkbox, Field, FieldError, FieldLabel } from "@/components/ui";
import type {
  ControllerFieldState,
  ControllerRenderProps,
} from "react-hook-form";
import type {
  AOEAnswerCoding,
  AOEQuestion,
} from "../../../network/useRetrieveAOEForOrder";
import type { AOEFormSchema } from "../schemas";

export const CheckboxQuestion = ({
  question,
  field,
  fieldState,
  disabled,
}: {
  question: AOEQuestion;
  field: ControllerRenderProps<
    AOEFormSchema,
    `questionnaires.${string}.${string}`
  >;
  fieldState: ControllerFieldState;
  disabled: boolean;
}) => {
  const value = field.value as AOEAnswerCoding | undefined;

  return (
    <Field data-invalid={fieldState.invalid}>
      <FieldLabel htmlFor={field.name}>
        {question.required && "*"}
        {question.question}
      </FieldLabel>
      <Checkbox
        checked={value?.code === "Y"}
        onCheckedChange={(checked) => {
          field.onChange({
            code: checked ? "Y" : "N",
            display: checked ? "Yes" : "No",
          });
        }}
        disabled={disabled}
        aria-invalid={fieldState.invalid}
      />
      <FieldError errors={[fieldState.error]} />
    </Field>
  );
};
